import { render, staticRenderFns } from "./CommonLoadingIcon.vue?vue&type=template&id=3020b3d8"
import script from "./CommonLoadingIcon.vue?vue&type=script&lang=js"
export * from "./CommonLoadingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports